import { uiActions } from '../store/ui-slice';
import { appConfigActions } from '../store/appConfig-slice';

import { axiosIntanceVinco } from '../core/api-config';
import {
  BASE_IMG_URL,
  NAVIGATION_PATHS,
} from '../constants/constants';

/**
 * In case where the API returns a certain response status or malformed
 * return data, it is possible that some kind of error was thrown from
 * the server.
 * Here, we analize the response in search of known error messages and
 * object structures to check if we can find the aprorpiate messages and
 * type of error
 *
 * @param {*} response The response object sent by the server.
 */

export const verifyErrors = (response) => {
  const statusErrors = ['error', 'warning', 'errors'];
  const { data } = response;
  if (data?.errors) {
    // Many errors so we join them together and in the component we
    // display them one <p> at a time.
    const errorKeys = Object.keys(data.errors);
    let errorMessages = 'Se encontraron los siguientes errores:';
    errorKeys.forEach((errKey) => {
      errorMessages = `${errorMessages}%%${data.errors[errKey][0]}`;
    });

    throw new Error(errorMessages);
  } else if (statusErrors.includes(data.status)) {
    throw new Error(data.message);
  } else if (statusErrors.includes(data.data?.status)) {
    throw new Error(data.data.message);
  }
};

/**
 * Strips all non numeric characters to add forward slashes and
 * format the input as a DD/MM/YYYY date with a Field input
 * from Formik.
 *
 * Usage:
 * <Field
 * name="MiFecha"
 * onChange={(event) => maskDateInput(event, setFieldValue, 'MiFecha')} />
 *
 * @param {*} event The synth event
 * @param {*} setFieldValue Formik's field value setting function
 * @param {*} fieldName The name of the field
 */
export const maskDateInput = (event, setFieldValue, fieldName) => {
  const value = event.target.value.replace(/\D/g, '');
  let newValue = '';
  if (value.length <= 2) {
    newValue = value;
  } else if (value.length > 2 && value.length <= 4) {
    newValue = `${value.slice(0, 2)}/${value.slice(2)}`;
  } else if (value.length > 4) {
    newValue = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4)}`;
  }
  setFieldValue(fieldName, newValue);
};

export const getDesiredCoverages = (type, coverages) => {
  return Object
    .keys(coverages.coberturas)
    .map((key) => {
      return {
        ...coverages.coberturas[key],
        key,
      };
    })
    .filter((e) => (
      (type === 'included' && !Number.isNaN(Number(e.montoCobertura)))
      || (type === 'excluded' && Number.isNaN(Number(e.montoCobertura)))
    ));
};

export const getImageURL = (url) => (`${BASE_IMG_URL}${url}`);

export const formatDateForBackend = (date) => {
  const dateArray = date.split('/');
  return `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`;
};

export const scrollIntoView = () => {
  document
    .querySelector('body')
    .scrollIntoView({
      behavior: 'smooth',
    });
};

export const doNavigation = (currentStep, direction, navigate, dispatch, clearForm) => {
  const newQuoterStep = direction === 'forward' ? currentStep + 1 : currentStep - 1;
  dispatch(appConfigActions.setQuoterCurrentStep({ newQuoterStep }));
  navigate(`${NAVIGATION_PATHS[newQuoterStep]}`, { replace: true });
  if (clearForm) {
    dispatch(uiActions.clearLoaderStatus());
  }
  scrollIntoView();
};

/**
 * Logs the response from an api call to our logging system.
 *
 * Valid stages:
 * Quote selection (form 3)
 * Payment (form 7 step 1)
 * Policy emission (Form 7 step 2)
 * Policy retrival (form 7 step 3)
 *
 * @param {string} idProcess
 * @param {string} stage
 * @param {number} httpStatus
 * @param {string} message
 * @param {string} endpoint
 */
export const logResponseFromAPI = (
  idProcess,
  stage,
  httpStatus,
  message,
  endpoint,
  otherData = {},
) => {
  const data = {
    identificador: idProcess,
    timeStampFrontend: new Date().toString(),
    etapa: stage,
    requests: [{
      httpStatus,
      message,
      endpoint,
    }],
    otherData,
  };

  axiosIntanceVinco({ method: 'POST', data });
};
